import FloorPlanImageAtIndex from "./FloorPlanImageAtIndex";

interface FloorPlanPreviewRendererProps {
  propertyId?: string;
  index?: string;
}

/**
 * Renderer component for floor plan image preview
 * Handles validation and rendering of floor plan images by index
 */
const FloorPlanPreviewRenderer = ({
  propertyId,
  index,
}: FloorPlanPreviewRendererProps) => {
  if (!propertyId || index === undefined || index === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-600 mb-2">
            Invalid Parameters
          </h2>
          <p className="text-gray-500">
            Property ID and image index are required.
          </p>
        </div>
      </div>
    );
  }

  const imageIndex = parseInt(index, 10);
  if (isNaN(imageIndex)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-600 mb-2">
            Invalid Index
          </h2>
          <p className="text-gray-500">Image index must be a valid number.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="floor-plan-preview-container min-h-screen bg-gray-50">
      <div className="flex flex-col items-center">
        <FloorPlanImageAtIndex
          propertyId={propertyId}
          imageIndex={imageIndex}
        />
      </div>
    </div>
  );
};

export default FloorPlanPreviewRenderer;
